// extracted by mini-css-extract-plugin
module.exports = {"root":"_ab9233","free":"_d8793b","tag":"_6dfbc6"};